var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcControlPointMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:1.5px;}.cls-1{stroke-linejoin:round;}.cls-2{stroke-linejoin:bevel;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-users-time"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.5,21l.79-2.87C4.6,13.4,8.05,11,11.5,11"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 11.5,
    cy: 5.99,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.5,
    cy: 18.01,
    r: 5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16.2 15.38 16.2 18.36 19.13 18.36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcControlPointMenu);
export default __webpack_public_path__ + "static/media/ic_control_point_menu.52427bb158434d419cc69ba62403bed3.svg";
export { ForwardRef as ReactComponent };